module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-step-02-af88208aa404a196ac9cba881a41ccb4.jpg";